import { Mail } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_zulu-landing-hub/artifacts/jbf0rehr_horizontal-black.png";

const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative py-20 sm:py-28 overflow-hidden"
      style={{ backgroundColor: "#0A0A0A" }}
    >
      {/* Giant background text */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none">
        <span
          className="text-[12vw] font-black text-white/[0.02] tracking-tighter uppercase whitespace-nowrap"
          style={{ fontFamily: "'Syne', sans-serif" }}
        >
          ZULUNITY
        </span>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <div className="border-t border-white/[0.06] pt-12">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
            <div>
              <img
                src={LOGO_URL}
                alt="Zulunity"
                className="h-8 w-auto mb-4"
              />
              <a
                href="mailto:contact@zulunity.com"
                data-testid="footer-email"
                className="flex items-center gap-2 text-sm text-neutral-400 hover:text-white transition-colors"
              >
                <Mail className="w-4 h-4" />
                contact@zulunity.com
              </a>
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 text-xs text-neutral-500">
              <a
                href="https://zulunity.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition-colors"
              >
                zulunity.com
              </a>
              <span className="hidden sm:inline text-white/10">|</span>
              <span>&copy; {new Date().getFullYear()} Zulunity. Todos los derechos reservados.</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
